<template>
  <aside class="d-flex flex-column flex-shrink-0 p-3 text-white bg-dark" style="width: var(--menu-width); min-height: 100vh;">
    <img src="@/assets/logo.png" alt="Optimal City">
    <small class="align-self-center">{{ version }}</small>
    <hr>
    <user-menu/>
    <hr>
    <ul class="nav nav-pills flex-column">
      <nav-link v-if="user.admin" to="users" name="Пользователи" icon="bi-person-lines-fill"/>
      <nav-link v-if="user.admin" to="inventory" name="Инвентарь" icon="bi-tools"/>
      <nav-link v-if="user.admin" to="projects" name="Проекты" icon="bi-gear"/>
      <nav-link to="myprojects" name="Мои проекты" icon="bi-gear-wide"/>
      <nav-link v-if="user.admin&&config.devMode" to="developer" name="Отладка" icon="bi-wrench-adjustable"/>
      <nav-link v-if="user.admin&&config.devMode" to="loadtest" name="Нагрузка" icon="bi-minecart-loaded"/>
    </ul>
  </aside>
</template>

<script>
import UserMenu from "./UserMenu";
import NavLink from "./NavLink";
import {version} from "../../package.json"
import {auth} from "@/state/auth";
import {config} from "@/state/config";

export default {
  components: {NavLink, UserMenu},
  computed: {
    version() {
      return version;
    },
    user() {
      return auth.user;
    },
    config() {
      return config;
    },
  }

}
</script>

<style>
:root {
  --menu-width: 15rem !important;
}
</style>